module.exports = __webpack_public_path__ + "img/checkboxtick.ef2340ea.svg";